export const enum BaseballResultId {
  Result = 2,
  FirstInning = 154,
  SecondInning = 155,
  ThirdInning = 156,
  FourthInning = 157,
  FifthInning = 158,
  SixthInning = 159,
  SeventhInning = 160,
  EighthInning = 161,
  NinthInning = 162,
  TenthInning = 169,
  EleventhInning = 170,
  TwelfthInning = 171,
  ThirteenthInning = 172,
  FourteenthInning = 173,
  FifteenthInning = 174,
  SixteenthInning = 175,
  SeventeenthInning = 176,
  EighteenthInning = 177,
  NineteenthInning = 178,
  TwentiethInning = 179,
  TwentyFirstInning = 180,
  TwentySecondInning = 181,
  TwentyThirdInning = 182,
}
